import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import MenuSettingModel, { ResponseModel, RetaurantInfo } from "../menuSetting.model";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";

@Component({
  selector: "ngx-connect-online-menu",
  templateUrl: "./connect-online-menu.component.html",
  styleUrls: ["./connect-online-menu.component.scss"],
})
export class ConnectOnlineMenuComponent extends BaseFormComponent<MenuSettingModel> {
  logoFormData: FormData = new FormData();
  ngUnsubscribe = new Subject<void>();
  testConnection: ResponseModel;
  GetInfo: boolean;
  response: ResponseModel;
  showItem: ResponseModel;
  ResInfo: RetaurantInfo;
  isLoading: boolean;
  showBtn: boolean;
  isRegister: boolean;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private splashFormService: SplashFormService) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "Peripheral";
    this.label = "";
    super.ngOnInit();
  }

  valueChangeBranch() {
    throw new Error("Method not implemented.");
  }

  ConnectionTest() {
    this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.PleaseWait"));
    this.isLoading = true;
    this.httpCommonService
      .get("UserLocalSetting/MenuOnlineConnection")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: ResponseModel) => {
          this.splashFormService.closeLoading();
          this.isLoading = false;
          this.testConnection = data;
          this.showBtn = true;
          if (this.testConnection.Code == 0) {
            this.isRegister = true;
          }
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.ConnectionWithOnlineMenuEstablished"),
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.Attention")
          );
        },
        (err) => {
          this.splashFormService.closeLoading();
          this.isLoading = false;
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.ConnectionWithOnlineMenuNotEstablished"),
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.Attention")
          );
        }
      );
  }

  ShowInfo() {
    this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.PleaseWait"));
    this.isLoading = true;
    this.httpCommonService
      .get("UserLocalSetting/GetRsetaurantInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: RetaurantInfo) => {
          this.splashFormService.closeLoading();
          this.isLoading = false;
          this.ResInfo = data;
          this.GetInfo = true;
          console.log(this.ResInfo.Urls);
        },
        (err) => {
          this.splashFormService.closeLoading();
          this.isLoading = false;
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.CollectionNotRegisteredMenuOnline"),
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.Attention")
          );
        }
      );
  }

  Register() {
    this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.PleaseWait"));
    this.isLoading = true;
    this.httpCommonService
      .get("UserLocalSetting/Register")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          this.splashFormService.closeLoading();
          this.isLoading = false;
          this.response = data;
          this.isRegister = true;
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.RegistrationSuccessful"),
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.Attention")
          );
        },
        (err) => {
          this.splashFormService.closeLoading();
          this.isLoading = false;
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.RegistrationOnlineMenuEncounteredError"),
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.Attention")
          );
        }
      );
  }

  SendItemCategoryInfo() {
    this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.PleaseWait"));
    this.isLoading = true;
    this.httpCommonService
      .get("UserLocalSetting/GetAllItemCategory")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          this.splashFormService.closeLoading();
          this.isLoading = false;
          this.showItem = data;
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.ProductRegistrationSuccessfullyCompleted"),
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.Attention")
          );
        },
        (err) => {
          this.splashFormService.closeLoading();
          this.isLoading = false;
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.ProductRegistrationEncounteredError"),
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.Attention")
          );
        }
      );
  }

  SendItemInfo() {
    this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.PleaseWait"));
    this.isLoading = true;
    this.httpCommonService
      .get("UserLocalSetting/GetAllItems")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          this.splashFormService.closeLoading();
          this.isLoading = false;
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.ProductRegistrationSuccessfullyCompleted"),
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.Attention")
          );
        },
        (err) => {
          this.isLoading = false;
          this.splashFormService.closeLoading();
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.ProductRegistrationEncounteredError"),
            this.translate("ClientApp.FrontOffice.Portal.ConnectOnlineMenu.Attention")
          );
        }
      );
  }

  copyInputMessage(inputElement) {
    inputElement.select();
    document.execCommand("copy");
    inputElement.setSelectionRange(0, 0);
  }
}
